export const testContentFilter = {
  columnId: 'isTestContent',
  condition: 'equals',
  value: 'false',
};

export enum EventStatusType {
  Notstarted = 0,
  Inprogress = 1,
  Finished = 2,
  Cancelled = 3,
  Postponed = 4,
}

export enum AlignTypes {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
  INHERIT = 'inherit',
  JUSTIFY = 'justify',
}
